import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';

// Styled components for consistent table styling across BVT components
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "Titillium Web, sans-serif",
  fontSize: '14px',
  padding: '3px 8px', // Row Padding
  '&.table-header': {
    fontWeight: 'bold',
    backgroundColor: '#083D61',
    color: 'white',
    padding: '10px 16px', // Header Padding
  },
  '&.section-header': {
    fontWeight: 'bold',
    backgroundColor: '#f5f5f5',
    fontStyle: 'italic',
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: '20px', 
  '&:nth-of-type(odd)': {
    backgroundColor: '#f9f9f9',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  '&:hover': {
    backgroundColor: '#f0f0f0',
  },
}));

// Root styled component for BVT components
export const Root = styled('div')(({ theme }) => ({
  [`& .bvt-table`]: {
    minWidth: 500,
    whiteSpace: "nowrap",
  },
  [`& .bvt-tableContainer`]: {
    overflowX: "auto",
  },
  [`& .bvt-statusIcon`]: {
    verticalAlign: "middle",
    marginRight: "8px",
  },
  [`& .bvt-red`]: {
    color: "red",
  },
  [`& .bvt-green`]: {
    color: "green",
  },
  [`& .bvt-copyButton`]: {
    margin: "10px 0",
  },
  [`& .bvt-excelButton`]: {
    backgroundColor: "#1e613b",
    color: "white",
    margin: "10px 0px 10px 10px",
    "&:hover": {
      backgroundColor: "#1e613b",
    },
  },
  [`& .bvt-negativeCostNumber`]: {
    color: "green",
  }
}));